import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import { Tabs, Tab } from 'react-bootstrap';
import MapboxHeatmap from '../../components/mapboxHeatmap/MapboxHeatmap';
import CheckInTrendsChart from '../../components/checkinTrendsChart/CheckinTrendsChart';
import PlayerLeaderboard from '../../components/playerLeaderboard/PlayerLeaderboard';
import BadgeRedemptions from '../../components/badgeRedemptions/BadgeRedemptions';
import './businessDashboard.css';

const BusinessDashboard = () => {
  const { player } = useContext(AuthContext);
  const [key, setKey] = useState('trends');
  const { businessId } = useParams();
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const days = 30;
  const zoom = 15;

  useEffect(() => {
    const fetchBusiness = async () => {
      try {
        const { data } = await axiosConn.get(`/businesses/${businessId}`, {
          headers: {
            Authorization: `Bearer ${player?.token}`,
          },
        });
        setBusiness(data.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    if (businessId) fetchBusiness();
  }, [businessId, player?.token]);

  if (loading) return <div>Loading dashboard...</div>;
  if (!business) return <div>Business not found.</div>;

  const region = business?.region || 'global';
  const city = business?.city || '';

  return (
    <div className="container mt-4">
      <h2 className="mb-4">📊 Business Analytics Dashboard</h2>

      <Tabs
        id="dashboard-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
        fill
      >
        <Tab eventKey="trends" title="Trends">
          <MapboxHeatmap
            key={`${businessId}-${region}-${city}`} // force clean remount if scope changes
            region={region}
            city={city}
            days={days}
            huntId={null}
            businessId={businessId}
            zoom={zoom}
            visible={key === 'heatmap'}
          />
          <CheckInTrendsChart
            businessId={businessId}
            region={region}
            city={city}
          />
        </Tab>
        <Tab eventKey="leaderboard" title="Top Players">
          <div className="business-leaderboard-card">
            <h5>
              <span role="img" aria-label="leaderboard">
                🏆
              </span>{' '}
              Visitors Leaderboard
            </h5>
            <PlayerLeaderboard
              businessId={businessId}
              region={region}
              limit={10}
            />
          </div>
        </Tab>
        <Tab eventKey="badges" title="Badge Redemptions">
          <BadgeRedemptions businessId={businessId} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default BusinessDashboard;
